export const RESTAURANT_ID = 'aba4adab-dfbe-47f1-bc31-9c0ee857a912';
export const CAMPAIGN_ID = 'f41569e6-889d-4733-83b3-a1002c26dace';
export const USER_ID = 'd0a8c61d-b8d3-4db1-822c-da35e44c4174';
export const DEVICE_TOKEN = '10a8acb7';
export const IS_GUEST = false;
export const QRStyle = 'Light';
